import { ArrowRight, HardHat, ConstructionIcon } from 'lucide-react';

const APP_URL = 'https://app.theonestack.com/build';
const ORANGE = '#f97316';

const pills = [
  'Job Tracking',
  'Estimates & Proposals',
  'Contracts & E-Sign',
  'Change Orders',
  'Lien Waivers',
  'Sub Portal',
];


export function HeroSection() {
  return (
    <section className="relative flex min-h-screen items-center justify-center overflow-hidden pt-16">
      {/* Orange radial glow — sits above the blueprint */}
      <div
        className="pointer-events-none absolute inset-0 z-10"
        style={{
          background: `radial-gradient(ellipse 70% 50% at 50% 0%, ${ORANGE}12 0%, transparent 70%)`,
        }}
      />

      {/* Blueprint / floorplan SVG overlay */}
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        <svg
          className="blueprint-bg absolute inset-0 h-full w-full"
          viewBox="0 0 1200 800"
          preserveAspectRatio="xMidYMid slice"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <defs>
            <pattern id="bp-grid" width="40" height="40" patternUnits="userSpaceOnUse">
              <path d="M 40 0 L 0 0 0 40" fill="none" stroke="rgba(59,130,246,0.06)" strokeWidth="0.5" />
            </pattern>
            <pattern id="bp-grid-major" width="200" height="200" patternUnits="userSpaceOnUse">
              <path d="M 200 0 L 0 0 0 200" fill="none" stroke="rgba(59,130,246,0.1)" strokeWidth="0.8" />
            </pattern>
          </defs>

          {/* Subtle blueprint paper tint */}
          <rect width="1200" height="800" fill="#0a1628" opacity="0.1" />

          {/* Fine grid */}
          <rect width="1200" height="800" fill="url(#bp-grid)" />
          {/* Major grid */}
          <rect width="1200" height="800" fill="url(#bp-grid-major)" />

          {/* Overall building outline */}
          <rect
            x="150" y="150" width="900" height="500"
            fill="none" stroke="rgba(59,130,246,0.16)" strokeWidth="2"
          />
          {/* Inner wall thickness */}
          <rect
            x="160" y="160" width="880" height="480"
            fill="none" stroke="rgba(59,130,246,0.1)" strokeWidth="1"
          />

          {/* Interior walls — rooms */}
          {/* Living Room (left-large) */}
          <path
            d="M 150 400 L 550 400 L 550 150"
            fill="none" stroke="rgba(59,130,246,0.14)" strokeWidth="1.5"
          />
          {/* Kitchen divider */}
          <path
            d="M 550 280 L 800 280 M 800 150 L 800 400"
            fill="none" stroke="rgba(59,130,246,0.14)" strokeWidth="1.5"
          />
          {/* Hallway & bedrooms */}
          <path
            d="M 150 500 L 1050 500 M 400 500 L 400 650 M 650 500 L 650 650 M 880 500 L 880 650"
            fill="none" stroke="rgba(59,130,246,0.14)" strokeWidth="1.5"
          />
          {/* Bath */}
          <path
            d="M 800 400 L 1050 400 M 920 400 L 920 500"
            fill="none" stroke="rgba(59,130,246,0.14)" strokeWidth="1.5"
          />

          {/* Window breaks (top wall) */}
          <line x1="250" y1="150" x2="320" y2="150" stroke="#0a1628" strokeWidth="3" />
          <line x1="420" y1="150" x2="490" y2="150" stroke="#0a1628" strokeWidth="3" />
          <line x1="620" y1="150" x2="690" y2="150" stroke="#0a1628" strokeWidth="3" />
          <line x1="850" y1="150" x2="920" y2="150" stroke="#0a1628" strokeWidth="3" />
          {/* Window sill lines */}
          <line x1="250" y1="150" x2="320" y2="150" stroke="rgba(59,130,246,0.2)" strokeWidth="0.6" />
          <line x1="420" y1="150" x2="490" y2="150" stroke="rgba(59,130,246,0.2)" strokeWidth="0.6" />

          {/* Door swing arcs */}
          <path d="M 400 500 A 40 40 0 0 1 440 540" fill="none" stroke="rgba(59,130,246,0.14)" strokeWidth="0.8" strokeDasharray="2 2" />
          <path d="M 650 500 A 40 40 0 0 1 690 540" fill="none" stroke="rgba(59,130,246,0.14)" strokeWidth="0.8" strokeDasharray="2 2" />
          <line x1="400" y1="500" x2="440" y2="500" stroke="rgba(59,130,246,0.18)" strokeWidth="1.2" />
          <line x1="650" y1="500" x2="690" y2="500" stroke="rgba(59,130,246,0.18)" strokeWidth="1.2" />

          {/* Staircase */}
          <g stroke="rgba(59,130,246,0.16)" strokeWidth="0.8" fill="none">
            <rect x="570" y="310" width="210" height="80" />
            <line x1="600" y1="310" x2="600" y2="390" />
            <line x1="630" y1="310" x2="630" y2="390" />
            <line x1="660" y1="310" x2="660" y2="390" />
            <line x1="690" y1="310" x2="690" y2="390" />
            <line x1="720" y1="310" x2="720" y2="390" />
            <line x1="750" y1="310" x2="750" y2="390" />
            <path d="M 675 310 L 675 390" stroke="rgba(59,130,246,0.22)" strokeDasharray="3 3" />
          </g>

          {/* Dimension lines (top) */}
          <g stroke="rgba(59,130,246,0.18)" strokeWidth="0.6" fill="none">
            <line x1="150" y1="110" x2="550" y2="110" />
            <line x1="150" y1="105" x2="150" y2="115" />
            <line x1="550" y1="105" x2="550" y2="115" />
            <line x1="550" y1="110" x2="1050" y2="110" />
            <line x1="1050" y1="105" x2="1050" y2="115" />
          </g>

          {/* Dimension lines (left) */}
          <g stroke="rgba(59,130,246,0.18)" strokeWidth="0.6" fill="none">
            <line x1="110" y1="150" x2="110" y2="500" />
            <line x1="105" y1="150" x2="115" y2="150" />
            <line x1="105" y1="500" x2="115" y2="500" />
            <line x1="110" y1="500" x2="110" y2="650" />
            <line x1="105" y1="650" x2="115" y2="650" />
          </g>

          {/* Hidden wall — dashed structural */}
          <line x1="150" y1="325" x2="550" y2="325" stroke="rgba(59,130,246,0.1)" strokeWidth="0.8" strokeDasharray="6 4" />
          <line x1="800" y1="575" x2="1050" y2="575" stroke="rgba(59,130,246,0.1)" strokeWidth="0.8" strokeDasharray="6 4" />

          {/* Compass rose — top right */}
          <g transform="translate(1100, 90)" stroke="rgba(59,130,246,0.25)" strokeWidth="0.8" fill="none">
            <circle r="28" />
            <circle r="20" />
            <path d="M 0 -28 L 4 -4 L 0 0 L -4 -4 Z" fill="rgba(59,130,246,0.2)" />
            <path d="M 0 28 L 4 4 L 0 0 L -4 4 Z" />
            <path d="M -28 0 L -4 -4 L 0 0 L -4 4 Z" />
            <path d="M 28 0 L 4 -4 L 0 0 L 4 4 Z" />
            <text x="0" y="-34" fontSize="8" fill="rgba(59,130,246,0.35)" textAnchor="middle" fontFamily="monospace">N</text>
            <text x="0" y="42" fontSize="8" fill="rgba(59,130,246,0.25)" textAnchor="middle" fontFamily="monospace">S</text>
            <text x="-36" y="3" fontSize="8" fill="rgba(59,130,246,0.25)" textAnchor="middle" fontFamily="monospace">W</text>
            <text x="36" y="3" fontSize="8" fill="rgba(59,130,246,0.25)" textAnchor="middle" fontFamily="monospace">E</text>
          </g>

          {/* Room labels — tiny blueprint text */}
          <g fill="rgba(59,130,246,0.28)" fontFamily="monospace" fontSize="9" letterSpacing="1">
            <text x="350" y="275" textAnchor="middle">LIVING RM</text>
            <text x="350" y="288" textAnchor="middle" fontSize="7" fill="rgba(59,130,246,0.18)">18'-0" x 14'-6"</text>
            <text x="675" y="220" textAnchor="middle">KITCHEN</text>
            <text x="925" y="275" textAnchor="middle">DINING</text>
            <text x="275" y="595" textAnchor="middle">BEDROOM 1</text>
            <text x="525" y="595" textAnchor="middle">BEDROOM 2</text>
            <text x="765" y="595" textAnchor="middle">HALL</text>
            <text x="860" y="465" textAnchor="middle">BATH</text>
            <text x="985" y="465" textAnchor="middle">W.C.</text>
            <text x="965" y="595" textAnchor="middle">MASTER</text>
            <text x="675" y="355" textAnchor="middle" fontSize="7" fill="rgba(59,130,246,0.22)">STAIR UP</text>
          </g>

          {/* Title block (bottom right) */}
          <g transform="translate(1020, 720)" stroke="rgba(59,130,246,0.2)" fill="none" strokeWidth="0.6">
            <rect width="140" height="60" />
            <line x1="0" y1="20" x2="140" y2="20" />
            <line x1="0" y1="40" x2="140" y2="40" />
            <text x="6" y="13" fontSize="7" fill="rgba(59,130,246,0.3)" fontFamily="monospace">THE ONE BUILD</text>
            <text x="6" y="33" fontSize="6" fill="rgba(59,130,246,0.22)" fontFamily="monospace">PLAN A-101</text>
            <text x="6" y="53" fontSize="6" fill="rgba(59,130,246,0.22)" fontFamily="monospace">SCALE 1/4" = 1'</text>
          </g>

          {/* Faint crane silhouette — watermark */}
          <g transform="translate(980, 420)" stroke="rgba(249,115,22,0.07)" strokeWidth="1.2" fill="none">
            <path d="M 0 200 L 0 0 L 160 -30" />
            <line x1="0" y1="0" x2="30" y2="30" />
            <line x1="0" y1="30" x2="60" y2="0" />
            <line x1="0" y1="60" x2="90" y2="30" />
            <line x1="0" y1="90" x2="120" y2="60" />
            <line x1="120" y1="-22" x2="120" y2="10" />
            <circle cx="120" cy="18" r="5" />
            <path d="M -20 200 L 20 200 L 10 180 L -10 180 Z" />
          </g>
        </svg>
      </div>

      <div className="relative z-20 mx-auto max-w-6xl px-6">
        <div className="text-center">
          {/* Badge */}
          <div className="mb-6 flex items-center justify-center gap-3 animate-fade-up">
            <span className="rounded-full border border-build-700/50 bg-build-900/60 px-3 py-1 text-xs text-zinc-400">
              Part of The One Stack
            </span>
          </div>

          {/* Headline */}
          <h1 className="mb-6 text-4xl font-extrabold tracking-tight animate-fade-up animate-delay-100 sm:text-5xl lg:text-7xl">
            Run Your Jobs.{' '}
            <span
              className="bg-clip-text text-transparent"
              style={{ backgroundImage: `linear-gradient(135deg, #fbbf24, ${ORANGE})` }}
            >
              Not Paperwork.
            </span>
          </h1>

          {/* Subheadline */}
          <p className="mx-auto mb-8 max-w-2xl text-lg text-zinc-400 animate-fade-up animate-delay-200 sm:text-xl">
            Construction management software for the way you actually work. From estimate to final payment — no more
            lien-waiver nightmares, no more paper shuffling, no more chasing field crews for signatures.
          </p>

          {/* Feature pills */}
          <div className="mb-10 flex flex-wrap items-center justify-center gap-2 animate-fade-up animate-delay-300">
            {pills.map((pill) => (
              <span
                key={pill}
                className="feature-pill rounded-full border border-build-700/40 bg-build-900/40 px-3.5 py-1.5 text-xs font-medium text-amber-300/80"
              >
                {pill}
              </span>
            ))}
          </div>

          {/* CTAs */}
          <div className="flex flex-col items-center justify-center gap-4 sm:flex-row animate-fade-up animate-delay-400">
            <a
              href={APP_URL}
              className="group flex items-center gap-2 rounded-xl bg-orange-500 px-8 py-3.5 text-base font-semibold text-white transition hover:bg-orange-600"
            >
              Start Free Trial
              <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
            </a>
            <a
              href="#how-it-works"
              className="flex items-center gap-2 rounded-xl border border-build-700/40 bg-build-900/30 px-8 py-3.5 text-base font-semibold text-zinc-300 transition hover:bg-build-900/60"
            >
              <HardHat className="h-4 w-4" />
              See How It Works
            </a>
          </div>

        </div>

        {/* Dashboard mockup */}
        <div className="mt-16 animate-fade-up animate-delay-600">
          <div className="mx-auto max-w-4xl">
            <div className="mockup-window">
              <div className="mockup-titlebar">
                <div className="mockup-dot" style={{ background: '#ef4444' }} />
                <div className="mockup-dot" style={{ background: '#f59e0b' }} />
                <div className="mockup-dot" style={{ background: '#22c55e' }} />
                <span className="ml-2 text-xs text-zinc-500">The One Build - Dashboard</span>
              </div>
              <div className="p-5">
                {/* Stats row */}
                <div className="mb-4 grid grid-cols-4 gap-3">
                  {[
                    { label: 'Active Jobs', value: '12', color: '#f97316' },
                    { label: 'Open Estimates', value: '8', color: '#fbbf24' },
                    { label: 'Pending Payments', value: '$47,200', color: '#22c55e' },
                    { label: 'Lien Waivers Due', value: '3', color: '#ef4444' },
                  ].map((stat) => (
                    <div key={stat.label} className="rounded-lg border border-build-700/30 bg-build-800/40 p-3">
                      <p className="text-[10px] text-zinc-500">{stat.label}</p>
                      <p className="text-lg font-bold" style={{ color: stat.color }}>{stat.value}</p>
                    </div>
                  ))}
                </div>
                {/* Job list preview */}
                <div className="rounded-lg border border-build-700/20 bg-build-800/20">
                  <div className="flex items-center justify-between border-b border-build-700/20 px-4 py-2">
                    <span className="text-xs font-medium text-orange-400">Active Jobs</span>
                    <span className="rounded bg-orange-500/15 px-2 py-0.5 text-[10px] font-medium text-orange-300">12 jobs</span>
                  </div>
                  {[
                    { name: 'Johnson Residence - Kitchen Remodel', status: 'In Progress', amount: '$34,500', pct: 65 },
                    { name: 'Riverdale Office Complex', status: 'Estimating', amount: '$245,000', pct: 15 },
                    { name: 'Pine Valley HOA - Pool Deck', status: 'Contract Signed', amount: '$18,700', pct: 30 },
                    { name: 'Metro Bank Branch Buildout', status: 'Final Punch', amount: '$89,000', pct: 92 },
                  ].map((job) => (
                    <div key={job.name} className="flex items-center gap-3 border-b border-build-700/10 px-4 py-2.5 last:border-0">
                      <div className="flex-1 min-w-0">
                        <p className="text-xs font-medium text-zinc-300 truncate">{job.name}</p>
                        <p className="text-[10px] text-zinc-500">{job.status}</p>
                      </div>
                      <div className="text-right shrink-0">
                        <p className="text-xs font-medium text-zinc-300">{job.amount}</p>
                        <div className="mt-1 h-1 w-16 rounded-full bg-build-700/30">
                          <div className="h-full rounded-full bg-orange-500" style={{ width: `${job.pct}%` }} />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Faint construction icon watermark — bottom right */}
      <div className="pointer-events-none absolute bottom-10 right-10 z-0 opacity-[0.04]">
        <ConstructionIcon className="h-48 w-48 text-orange-500" strokeWidth={1} />
      </div>
    </section>
  );
}
